import { render, staticRenderFns } from "./TableDelete.vue?vue&type=template&id=5e15f02e&"
import script from "./TableDelete.vue?vue&type=script&lang=js&"
export * from "./TableDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports